import { withTheme } from "@mui/styles";
import ProofContainer from "./ProofContainer";
import ProofStore from "./ProofStore";

export default ProofStore(withTheme(ProofContainer));